module.exports = __webpack_public_path__ + "static/media/tutankhamun.4d48c4fb.jpg";